import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import styled from 'styled-components';
const infoSocial = [
  {
    name: 'Facebook',
    link: 'https://www.facebook.com/profile.php?id=100016244402322',
    icon: faFacebookF
  },
  {
    name: 'Twitter',
    link: 'https://twitter.com/',
    icon: faTwitter
  },
  {
    name: 'Github',
    link: 'https://github.com/ElhamFadel',
    icon: faGithub
  },
  {
    name: 'Linkedin',
    link: 'https://www.linkedin.com/in/elham-elshami-1869191a0/',
    icon: faLinkedinIn
  }
];

const SocialContact = () => {
  return (
    <IconsContainer>
      {infoSocial.map((item) => (
        <LinkSocial key={item.name} href={item.link} target="_blank">
          <FontAwesomeIcon icon={item.icon} />
        </LinkSocial>
      ))}
    </IconsContainer>
  );
};

const LinkSocial = styled.a`
  color: #fff;
  margin: 0 3rem;
  cursor: pointer;
  font-size: 3rem;
  &:hover {
    color: #4e6e29;
  }
`;

const IconsContainer = styled.div`
  margin-bottom: 3rem;
`;

export default SocialContact;
